// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1-W9z","bigColWidth":"Table_bigColWidth__t8wMm","biggerColWidth":"Table_biggerColWidth__CG-1H","row":"Table_row__2YTPK","col":"Table_col__1bsoS"};